import React, { useState } from "react";
import { FoodAnalysisService } from "../services/foodAnalysisService";

const FoodDetective = ({ addToHistory }) => {
  const [inputText, setInputText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const analyzeText = async (text) => {
    setIsLoading(true);
    setResult(null);

    try {
      console.log("🔍 Starting enhanced food analysis...");
      const analysisResult = await FoodAnalysisService.analyzeText(text);

      setResult(analysisResult);
      addToHistory(
        text,
        analysisResult.isSafe,
        analysisResult.confidence,
        analysisResult.reason
      );
    } catch (error) {
      console.error("❌ Error in food analysis:", error);
      const fallbackResult = {
        isSafe: false,
        confidence: 0.3,
        reason: "Analysis failed - please check ingredients manually",
        source: "Error",
      };
      setResult(fallbackResult);
      addToHistory(text, false, 0.3, fallbackResult.reason);
    } finally {
      setIsLoading(false);
    }
  };

  const analyzeImage = async (file) => {
    setIsLoading(true);
    setResult(null);

    try {
      console.log("📸 Starting enhanced image analysis...");
      const analysisResult = await FoodAnalysisService.analyzeImage(file);

      setResult(analysisResult);
      addToHistory(
        file.name,
        analysisResult.isSafe,
        analysisResult.confidence,
        analysisResult.reason
      );
    } catch (error) {
      console.error("❌ Error in image analysis:", error);
      const fallbackResult = {
        isSafe: false,
        confidence: 0.3,
        reason:
          "Image analysis failed - please try text input or check ingredients manually",
        source: "Image Analysis Error",
      };
      setResult(fallbackResult);
      addToHistory(file.name, false, 0.3, fallbackResult.reason);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim()) {
      analyzeText(inputText.trim());
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      analyzeImage(file);
    }
  };

  return (
    <div className="view active">
      <div className="input-card">
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", gap: "2rem", marginBottom: "1rem" }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">
                🔍 What food would you like to check, girlfriend?
              </label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter food name or ingredients..."
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">
                📸 Or upload a photo of the food label
              </label>
              <input
                type="file"
                className="form-input"
                accept="image/*"
                onChange={handleFileUpload}
              />
              {selectedFile && (
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.8)",
                    fontSize: "0.9rem",
                    marginTop: "0.5rem",
                  }}
                >
                  Selected: {selectedFile.name}
                </p>
              )}
            </div>
          </div>
          <button
            type="submit"
            className="check-btn"
            disabled={isLoading || !inputText.trim()}
          >
            {isLoading && <span className="loading-spinner"></span>}
            {isLoading ? "Analyzing..." : "Check Food Safety"}
          </button>
        </form>
      </div>

      {result && (
        <div className="result-card">
          <div className="result-header">
            <span className="result-icon">{result.isSafe ? "✅" : "⚠️"}</span>
            <div>
              <h3 className="result-title">
                {result.isSafe
                  ? "You're good to go, girlfriend! 💅"
                  : "Oh no, girlfriend! 😤"}
              </h3>
              <p className="result-subtitle">
                Confidence: {Math.round(result.confidence * 100)}% | Source:{" "}
                {result.source}
              </p>
            </div>
          </div>
          <p className="result-message">
            {result.isSafe
              ? `🎉 ${result.reason} Go ahead and enjoy, darling!`
              : `🚫 ${result.reason} Not today, sweetie!`}
          </p>
        </div>
      )}
    </div>
  );
};

export default FoodDetective;
